import type { Parking, Price } from '@/service'

export interface ParkingDisplayPrice {
  price: Price
  periodInDays?: number
  source: 'plan' | 'pricePer24Hours' | 'lastPricePerHour' | 'pricePerHour'
}

const DISPLAY_PERIOD_PRIORITY = [7, 30, 1]

export const selectParkingDisplayPrice = (
  parkingPrice?: Parking['price']
): ParkingDisplayPrice | null => {
  if (!parkingPrice) return null

  for (const periodInDays of DISPLAY_PERIOD_PRIORITY) {
    const plan = parkingPrice.plans?.find(
      item => item.period?.value === periodInDays && item.priceObject
    )

    if (plan) {
      return {
        price: plan.priceObject,
        periodInDays,
        source: 'plan'
      }
    }

    if (periodInDays === 1 && parkingPrice.pricePer24Hours) {
      return {
        price: parkingPrice.pricePer24Hours,
        periodInDays,
        source: 'pricePer24Hours'
      }
    }
  }

  if (parkingPrice.lastPricePerHour) {
    return {
      price: parkingPrice.lastPricePerHour,
      source: 'lastPricePerHour'
    }
  }

  return parkingPrice.pricePerHour
    ? { price: parkingPrice.pricePerHour, source: 'pricePerHour' }
    : null
}
